// Обратный отсчёт до дедлайна операции терминала. Срок приходит с бэка вместе с operationId,
// таймер не реактивный: живёт на инстансе, чистится в stopCountdown и beforeDestroy
export default {
  data () {
    return {
      remainingSeconds: null,
    }
  },
  beforeDestroy () {
    this.stopCountdown()
  },
  methods: {
    startCountdown (seconds) {
      this.stopCountdown()
      this.remainingSeconds = Math.max(0, Math.round(seconds || 0))
      this.countdownTimer = setInterval(() => {
        if (this.remainingSeconds > 0) this.remainingSeconds -= 1
        if (this.remainingSeconds === 0) this.stopCountdown({ keepValue: true })
      }, 1000)
    },
    stopCountdown ({ keepValue = false } = {}) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
      if (!keepValue) this.remainingSeconds = null
    },
    terminalWaitingHint () {
      const wait = this.remainingSeconds > 0
        ? `Ждём ответ терминала ещё ${this.remainingSeconds} с.`
        : 'Ждём ответ терминала.'

      // KkmServer не прерывает операцию Сбера (pilot_nt): закрытие окна её не отменяет
      return `${wait} CRM не может прервать операцию - отменить её можно красной кнопкой на терминале. ` +
        'Окно можно закрыть: итог придёт уведомлением.'
    },
  },
}
